import { Autocomplete, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useFetchProjectbasedTasklistQuery, useFetchUserAccessedProjectsQuery,
  // useFetchuserbasedTasksQuery,
} from "../../../slice/logdetailSlice";
import { customFilterOptions } from "../CommonAddLogHour";
import { BtnLoader } from "../Loader";
import { FaClone } from "react-icons/fa6";
import { createEntity } from "../../../apis/apiService";
import { toast } from "react-toastify";


const Movetask = ({
  handleMenuClose,
  login_user_id,
  selectedTask,
  path,
  // project_id,
  refetch_list,
}) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const { data: user_accessed_project, isLoading: project_loading } = useFetchUserAccessedProjectsQuery();
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      project_id: null,
      task_list_id: "",
    },
  });

  const { data: last_list_names } = useFetchProjectbasedTasklistQuery(selectedProjectId, {
    skip: !selectedProjectId,
  });
  //   console.log(" task_items last_list_names :", last_list_names);
  const onSubmit = async (data) => {
    setLoading(true);
    // console.log("task_items data :", data);
    const requestedData = {
      project_id: data.project_id,
      task_list_id: data.task_list_id,
      task_id: isNaN(selectedTask?.id)
        ? parseInt(selectedTask?.id?.toString().replace(/[^\d]/g, ""))
        : selectedTask?.id,
    };
    try {
      const response = await createEntity(path, requestedData);
      if (response) {
        toast.success(response.message);
        refetch_list();
      }
    } 
    catch (error) {
      toast.error(error.message);
    } 
    finally {
      handleMenuClose();
      setPopupOpen(false);
      setLoading(false);
    }
  };

  //   const {
  //     data: taskNameOptions,
  //     refetch: project_based_task_name_refetch,
  //     isLoading: task_name_loading,
  //   } = useFetchuserbasedTasksQuery({
  //     user_id: login_user_id,
  //     project_id: selectedProjectId,
  //   });

  const formatTaskOptions = (data) => {
    const options = [];

    if (!data) return options;
    // Format project_task_lists
    if (Array.isArray(data.project_task_lists)) {
      options.push({
        title: "Project Task Lists",
        isHeader: true,
        type: "task_list",
      });

      data.project_task_lists.forEach((list) => {
        options.push({
          title: list.task_list_name,
          task_id: list.task_list_id,
          isHeader: false,
        });
      });
    }

    // Format milestone_task_lists
    if (Array.isArray(data.milestone_task_lists)) {
      options.push({
        title: "Milestone Task Lists",
        isHeader: true,
        type: "milestone",
      });

      data.milestone_task_lists.forEach((list) => {
        options.push({
          title: list.task_list_name,
          task_id: list.task_list_id,
          isHeader: false,
        });
      });
    }

    return options;
  };

  const formattedTaskOptions = formatTaskOptions(last_list_names);

  return (
    <>
      <MenuItem
        onClick={() => {
          setPopupOpen(true);
        }}
      >
        <FaClone className="me-2" color="blue" />
        Move Task
      </MenuItem>
      <Dialog
        open={popupOpen}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            minHeight: "70vh",
            width: "90%",
            maxWidth: "500px",
            borderRadius: "12px",
          },
        }}
        disableEscapeKeyDown
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setPopupOpen(false);
            reset();
          }
        }}
      >
        <DialogTitle>Move Task</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 1,
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="col-md-12">
                <label htmlFor="project_id" className="form-label">
                  Project name <span className="errorMsg">*</span>
                </label>
                <Controller
                  name="project_id"
                  control={control}
                  rules={{ required: "Project field is required" }}
                  render={({
                    field: { onChange, value },
                    formState: { errors },
                  }) => (
                    <>
                      <Autocomplete
                        id="project_id"
                        options={
                          Array.isArray(user_accessed_project)
                            ? user_accessed_project
                            : []
                        }
                        getOptionLabel={(option) => option?.title}
                        value={
                          user_accessed_project?.find(
                            (user) => user?.project_id === value
                          ) || null
                        }
                        loading={project_loading}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            if (Array?.isArray(newValue)) {
                              toast.error("You can select only one project.");
                            } else {
                              onChange(newValue?.project_id);
                              setSelectedProjectId(newValue?.project_id);
                            }
                          } else {
                            onChange(null);
                            setSelectedProjectId(null); // Reset selected user ID
                          }
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select project" />
                        )}
                      />
                      <span className="errorMsg">
                        {errors?.project_id?.message}
                      </span>
                    </>
                  )}
                />
              </div>
              
              {selectedProjectId && (
                <>
                  <div className="g-3  my-3 row">
                    <div className="col-md-12  mb-2">
                      <label htmlFor="task_list_id" className="form-label">
                        Task List
                      </label>
                      <Controller
                        name="task_list_id"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            // multiple
                            id="task_list_id"
                            options={formattedTaskOptions}
                            getOptionLabel={(option) => option.title}
                            disableCloseOnSelect
                            filterOptions={customFilterOptions}
                            isOptionEqualToValue={(option, value) =>
                              option.task_id === value.task_id
                            }
                            value={
                              formattedTaskOptions.find(
                                (opt) => opt.task_id === value
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              onChange(newValue ? newValue.task_id : null); // send integer or null
                            }}
                            renderOption={(props, option, { selected }) =>
                              option.isHeader ? (
                                <li
                                  {...props}
                                  style={{
                                    fontWeight: "bold",
                                    opacity: 0.8,
                                    pointerEvents: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    gridColumn: "1 / -1",
                                  }}
                                >
                                  {option.title}
                                </li>
                              ) : (
                                <li
                                  {...props}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  <strong>{option.title}</strong>
                                </li>
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select task"
                              />
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </>
              )}

              <DialogActions sx={{ marginY: "20px" }}>
                <button
                  type="button"
                  className="cancel_btn"
                  onClick={() => {
                    setPopupOpen(false);
                    reset();
                  }}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button type="submit" className="add_btn" disabled={loading}>
                  {loading ? (
                    <>
                      <BtnLoader />
                    </>
                  ) : (
                    "Apply"
                  )}
                </button>
              </DialogActions>
            </form>
          </LocalizationProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default Movetask;
